import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { ColoredCard } from '../style';
import { CardContent, Typography } from '../../../../ui-kit';
import { useUser } from '../../../../utils/hooks/auth';

interface DetailCardProps {
    title: string;
    itemsCount: number;
    value: number;
    onClick?: () => void;
}

const DetailCard: React.FC<DetailCardProps> = ({ title, itemsCount, value, onClick }) => {
    const { priceService } = usePriceService();
    const { t } = useTranslation();
    const { user: { defaultCurrency: { currencyCode } } } = useUser();

    return (
        <ColoredCard onClick={onClick} fullHeight>
            <CardContent padding={2}>
                <Tooltip title={title} aria-label={title} placement='top'>
                    <div>
                        <Typography gutterBottom variant='h5' noWrap>{title}</Typography>
                    </div>
                </Tooltip>

                <Typography variant='caption' color='textSecondary'>{t('Value')}</Typography>
                <Typography variant='body2' gutterBottom>{priceService.toLocaleString(value, currencyCode)}</Typography>

                <Typography variant='caption' color='textSecondary'>{t('Items')}</Typography>
                <Typography variant='body2' gutterBottom>{itemsCount}</Typography>
            </CardContent>
        </ColoredCard>
    );
};
export default DetailCard;
